import { Box, Paper } from '@mui/material';
import ReportTemplatesTable from './ReportTemplatesTable';
import useQuery from 'hooks/useQuery';
import { FormTemplateType } from 'api/models';
import { GeneralIds, ModelTypes } from 'types/types';
import { FormTemplateEditorMode } from 'routes/FormTemplateEditor/FormTemplateEditor';
import { useParams } from 'react-router-dom';

export default function ReportTemplates() {
  const { projectId } = useParams<GeneralIds>();
  const { data, loading, refetch } = useQuery<FormTemplateType[]>({
    type: ModelTypes.formTemplateType,
    queryParams: {
      type: FormTemplateEditorMode.report,
    },
    ids: { projectId: projectId },
  });

  return (
    <Box sx={{ mt: 2, pb: 2 }}>
      <Paper elevation={2}>
        <ReportTemplatesTable
          templates={data ?? []}
          loading={loading}
          refetch={refetch}
        />
      </Paper>
    </Box>
  );
}
